import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateUserRequest } from '../models/auth.model';
import { UserFilterPaginatedRequest, UserPaginatedResponse } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private http: HttpClient) {}

  getUserByUserId(userId: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/api/User/${userId}`);
  }

  createUser(data: CreateUserRequest): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/User`, data);
  }

  putUser(body: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}/api/User`, body);
  }

  filterPaginated(body: UserFilterPaginatedRequest): Observable<UserPaginatedResponse> {
    return this.http.post<UserPaginatedResponse>(`${environment.apiUrl}/api/User/filter-paginated`, body);
  }

  activateUser(id: string): Observable<any> {
    return this.http.patch(`${environment.apiUrl}/api/User/activate/${id}`, {});
  }

  deactivateUser(id: string): Observable<any> {
    return this.http.patch(`${environment.apiUrl}/api/User/deactivate?id=${id}`, {});
  }

  deleteUser(id: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/api/User`, { params: { id } });
  }
}
